const EventRsvp = `
  id
  description
  updatedAt
`;

export default EventRsvp;
